import React from 'react';
import { ActivityIndicator, FlatList, Image, Linking } from "react-native"
import { useEffect, useState } from "react";
import { Button, Text, View } from '../../../src/Components/Themed';
import { Icons } from '../../../src/Components';
import { useColors } from '../../../src/constants/useColors';
import type { AthleteProps, BracketPickStatProps, BracketProps, EventProps, MarketProps, PlayerBracketPickProps, RoundEventProps, TeamProps, TradeProps } from '../../../src/types';
import { BracketApi, BracketComeptitionApi } from '../../../src/Bracket/api';
import { MarketComponentApi } from '../../../src/MarketComponents/api';
import TeamEventMarket from '../../../src/MarketComponents/components/TeamEventMarket';

type RoundEventModalProps = {
    visible:boolean, 
    mode: 'desktop'|'mobile', 
    player_bracket_pick?:PlayerBracketPickProps,
    bracket?:BracketProps,
    round_event:RoundEventProps,
    onClose:() => void 
}

const RoundEventStats = ({ visible, mode, player_bracket_pick, round_event, bracket, onClose }:RoundEventModalProps) => {
    const Colors = useColors();
    const [ stats_data, setStatsData ] = useState<{
        loading:boolean,
        bracket_pick_stats:BracketPickStatProps[],
        event?:EventProps,
        teams:TeamProps[],
        markets:MarketProps[],
        athletes:AthleteProps[],
        latest_trades:TradeProps[],
    }>({
        loading:false,
        markets:[],
        bracket_pick_stats:[],
        teams:[],
        athletes:[],
        latest_trades:[]
    });
    const { loading, bracket_pick_stats, markets, latest_trades, teams, athletes, event } = stats_data;

    //const visible_modal = useAppSelector(state => state.modal.visible_modal, (left, right) => left == right);
    //const modal_options = useAppSelector(state => state.modal.modal_options, shallowEqual);
    const insets = { top:0, bottom:0, left:0, right:0 }

    const total_picks = bracket_pick_stats.reduce((a,b) => a + parseFloat(b.pick_count as unknown as string), 0);
    const my_team_pick = teams.find(t => t.team_id == player_bracket_pick?.pick_side_id)
    const my_pick_stats = bracket_pick_stats.find(s => s.pick_side_id == player_bracket_pick?.pick_side_id);
    const my_pick_num = my_pick_stats?.pick_count ?? 0
    const my_pick_ratio = my_pick_num / total_picks


    useEffect(() => {
        MarketComponentApi.setEnvironment();
        if(!visible || !round_event){ return }
        setUpStats()
    },[visible]);

    const setUpStats = async() => {
        if(!bracket){ return }
        setStatsData({ ...stats_data, loading: true });
        let ev:EventProps|undefined = undefined
        console.log('getting event')
        if(round_event?.event_id){ 
            //Get event!!!
            const evs = await MarketComponentApi.getEventsByEventIds([round_event.event_id])
            ev = evs[0]
        }
        const stats = await BracketComeptitionApi.getBracketPickStatsByBracket(bracket.bracket_id);
        
        const team_ids = stats.filter(s => s.pick_side_type == 'team').map(p => p.pick_side_id);
        const athlete_ids = stats.filter(s => s.pick_side_type == 'athlete').map(p => p.pick_side_id);
        const ts = await BracketApi.getTeamsByIds(team_ids);
        const aths = await BracketApi.getAthletesByIds(athlete_ids);
        const mks = await MarketComponentApi.getMarkets();
        let lts:TradeProps[] = []
        if(round_event.event_id){
            lts = await MarketComponentApi.getLatestTradesByEvents('team', [round_event.event_id]);
        }
        setStatsData({
            ...stats_data,
            event: ev,
            teams: ts,
            athletes: aths,
            markets: mks,
            latest_trades: lts,
            bracket_pick_stats: stats.filter(s => s.round_event_id == round_event.round_event_id)
        })
    }

    const renderContest = () => {
        if(!round_event || !bracket){ return <></> };
        if(!event){ return <></> }
        return (
            <TeamEventMarket
                event={event}
                latest_trades={latest_trades}
                best_available_orders={[]}
                event_order_stats={[]}
                markets={markets}
                default_price_view='last_trade'
                onView={() => console.log('')}
                hide_liquidity
                onOrder={(order) => Linking.openURL(`https://play.bettoredge.com`)}
                onCompetitionSelect={() => console.log('')}
                onSquaresSelect={() => console.log('')}
                onTradeLongPress={() => console.log('')}
                onViewAdditionalMarkets={() => console.log('')}
            />
        )
    }

    const renderStats = (data:{ item: BracketPickStatProps, index:number }) => {
        const team = teams.find(t => t.team_id == data.item.pick_side_id)
        const athlete = athletes.find(a => a.athlete_id == data.item.pick_side_id)
        const pct = data.item.pick_count / total_picks
        switch(data.item.pick_side_type){
            case 'athlete':
                if(!athlete){ return <></> }
                return (
                    <View type='row' style={{ padding:10 }}>
                       <Image
                            source={{ uri: athlete.image?.url }}
                            style={{ height:40, width:40 }}
                            resizeMode="cover"
                        />
                        <View style={{ flex:1, marginLeft:10 }}>
                            <Text theme="h1">{athlete.first_name} {athlete.last_name}</Text>
                            <Text style={{ marginTop:3 }} theme="light">{athlete.position}{athlete.team? `- ${athlete.team.abbr}`:''}</Text>
                        </View>
                        <View>
                            <Text theme="h1">{(pct * 100).toFixed(2)}%</Text>
                        </View>
                    </View>
                )
            case 'team':
                if(!team){ return <></> }
                return (
                    <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                        <Image
                            source={{ uri: team.image?.url }}
                            style={{ height:40, width:40 }}
                            resizeMode="cover"
                        />
                        <View style={{ flex:1, marginLeft:10 }}>
                            <Text theme="h1">{team.market_name} {team.name}</Text>
                            <Text style={{ marginTop:3 }} theme="light">{team.division}{team.sub_division?` - ${team.sub_division}`:''}</Text>
                        </View>
                        <View>
                            <Text theme="h1">{(pct * 100).toFixed(2)}%</Text>
                        </View>
                    </View>
                )
            default: return <></>
        }
    }


    return (

        <View type='blur' style={mode == 'desktop' ? { flex:1, justifyContent: 'center', alignItems:'center'} : { flex:1, justifyContent:'flex-end', paddingBottom:insets.bottom }}>
            <View float style={mode=='desktop'?{ width:500 }:{}}>
                {my_team_pick ?
                    <View type='header' style={{ flexDirection:'row', borderBottomWidth:1, borderColor:Colors.borders.light, alignItems:'center', borderTopLeftRadius:8, borderTopRightRadius:8, padding:10 }}>
                        <Image
                            source={{ uri: my_team_pick.image?.url }}
                            style={{ height:60, width:60 }}
                            resizeMode="cover"
                        />
                        <View transparent style={{ flex:1, marginLeft:10 }}>
                            <Text theme="description">MY PICK</Text>
                            <Text style={{ marginTop:4 }} theme="h1">{my_team_pick.market_name} {my_team_pick.name}</Text>
                        </View>
                        <View transparent>
                            <Text theme="h1" size={18} color={Colors.text.action}>{(my_pick_ratio * 100).toFixed(2)}%</Text>
                        </View>
                    </View>
                :
                <View type='header' style={{ flexDirection:'row', borderBottomWidth:1, borderColor:Colors.borders.light, alignItems:'center', borderTopLeftRadius:8, borderTopRightRadius:8, padding:10 }}>
                        <Icons.PickEmIcon size={32} color={Colors.text.h1} />
                        <View transparent style={{ flex:1, marginLeft:10 }}>
                            <Text theme="description">MY PICK</Text>
                            <Text style={{ marginTop:4 }} theme="h1">No Pick Detected</Text>
                        </View>
                        <View transparent>
                            <Text theme="h1" size={18} color={Colors.text.action}>{(my_pick_ratio * 100).toFixed(2)}%</Text>
                        </View>
                    </View>
                }
                
                <View type='body'>
                    <View nativeID="picks">
                        <View style={{ borderBottomWidth:1, borderColor:Colors.borders.light, padding:10 }}>
                            <Text theme="h1">Top Picks In This Round</Text>
                        </View>
                        <FlatList
                            key='pick_stats'
                            keyExtractor={(item) => item.pick_side_id.toString()}
                            data={bracket_pick_stats.sort((a,b) => b.pick_count - a.pick_count).slice(0,3)}
                            renderItem={renderStats}
                        />
                    </View>
                    <View nativeID="contest" style={{ padding:5, marginTop:20, marginBottom:20 }}>
                        {renderContest()}
                    </View>
                    {loading ?
                    <ActivityIndicator
                        size='large'
                        color={Colors.text.h1}
                        style={{ padding:20, alignSelf:'center' }}
                    />
                    :<></>}
                </View>
                <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                    <Button
                        type='close'
                        title="CLOSE"
                        style={{ flex:1 }}
                        onPress={() => onClose()}
                    />
                </View>
            </View>
        </View>

    )
}

export default RoundEventStats